export default __webpack_public_path__ + "static/media/gallery7.6e98fbd8.jpg";